import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { environment } from "../../environments/environment";
import { PoTableColumn } from "@po-ui/ng-components";

@Injectable({
  providedIn: "root",
})
export class AreaTecnicaAdminService {
  urlAcervos = `${environment.API}acervotecnico`;
  urlSimilar = `${environment.API}similar`;
  urlProdutos = `${environment.API}produtos`;
  headers = new HttpHeaders({'authorization':sessionStorage.getItem("token")});

  constructor(private http: HttpClient) {}

  getAcervos(segmento): Observable<any> {
    return this.http.post(this.urlAcervos, { seguimento: segmento },{headers: this.headers});
  }

  putAcervos(segmento, titulo, link, descricao): Observable<any> {
    return this.http.put(this.urlAcervos, {
      seguimento: segmento,
      titulo,
      link,
      descricao,
    },{headers: this.headers});
  }

  updateAcervos(id, segmento, titulo, link, descricao): Observable<any> {
    return this.http.patch(this.urlAcervos, {
      seguimento: segmento,
      titulo,
      link,
      descricao,
      id,
    },{headers: this.headers});
  }

  deletAcervos(id, segmento): Observable<any> {
    return this.http.delete(this.urlAcervos+"/"+id,{headers: this.headers});
  }

  getAcervoColumns(): Array<PoTableColumn> {
    return [
      { property: "id", width: "5%" },
      { property: "titulo", width: "20%" },
      { property: "descricao", width: "55%", label: "Descrição" },
      { property: "link", type: "link", width: "20%" },
    ];
  }
}
